exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wizard{background-color:#265390;width:280px;padding:15px;padding-bottom:74px;overflow-y:auto;position:fixed;left:0;top:60px;bottom:0}.wizard .wizardHeader{position:relative;margin:20px 0px;float:left;width:100%}.wizard .wizardHeader h4{color:#ffffff;font-size:22px;font-weight:300;margin-top:0}.wizard .wizardHeader a{color:#ffffff;font-size:12px;opacity:.7;position:absolute;top:4px;right:0}@media (max-width: 1366px){.wizard .wizardHeader{margin:12px 0px 10px}.wizard .wizardHeader h4{font-size:18px}}@media (min-width: 767px) and (max-width: 800px){.wizard{padding-bottom:112px}}@media (max-width: 767px){.wizard{right:0;top:60px;bottom:auto;height:100px;z-index:3;width:100%;padding:15px;overflow:hidden}.wizard .wizardHeader{margin:0}.wizard .wizardHeader h4{font-size:16px}}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/things/shared/wizard/wiz-menu.component.scss
// module id = 1393
// module chunks = 0